import { Link } from 'react-router-dom';
import type { Work } from '@/mocks/catalog';
import { typeLabel } from '@/mocks/catalog';

interface WorkCardProps {
  work: Work;
  className?: string;
  showPlayCount?: boolean;
}

export default function WorkCard({ work, className = '', showPlayCount = false }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-colors hover:border-accent-300 ${className}`}
      data-product-shop
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - ${work.genres.join(' ')} 高清资源`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 top-0 flex items-start justify-between p-2.5">
          <span className="rounded-md bg-foreground-950/75 px-2 py-0.5 font-label text-[11px] font-medium text-background-50 backdrop-blur-sm">
            {typeLabel[work.type]}
          </span>
          <span className="flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 font-label text-[11px] font-bold text-foreground-950">
            <i className="ri-star-fill text-[10px]"></i>
            {work.rating.toFixed(1)}
          </span>
        </div>
        {work.badge && (
          <span className="absolute bottom-2.5 left-2.5 rounded-md bg-primary-700/90 px-2 py-0.5 text-[11px] font-medium text-background-50">
            {work.badge}
          </span>
        )}
        <span className="absolute bottom-2.5 right-2.5 flex h-8 w-8 items-center justify-center rounded-full bg-background-50/90 text-foreground-900 opacity-0 transition-opacity group-hover:opacity-100">
          <i className="ri-play-fill text-sm"></i>
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-accent-700">{work.title}</h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {work.genres.slice(0, 2).join(' · ')} · {work.year}
        </p>
        <div className="mt-auto flex items-center justify-between pt-2 text-[11px] text-foreground-400">
          <span className="truncate">{work.region}</span>
          {showPlayCount ? (
            <span className="flex shrink-0 items-center gap-1 whitespace-nowrap">
              <i className="ri-fire-line text-accent-500"></i>
              {work.views}
            </span>
          ) : (
            <span className="shrink-0 whitespace-nowrap">{work.duration}</span>
          )}
        </div>
      </div>
    </Link>
  );
}